<template>
  <div class="sticky-bar">
    <div class="row mb-4">
      <div class="col-md-9">
        <router-link
          :to="{ path: mainPath + route.path }"
          class="btn btn btn-info mr-2"
          v-for="route in routes"
          :key="route.name"
        >
          <i :class="'fa fa-' + route.icon" aria-hidden="true"></i>
          {{ route.name }}
        </router-link>
      </div>
      <div class="col-md-3 text-right">
        <h4 class="text-bold">{{ title }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["routes"],
  data() {
    return {
      title:
        this.$route.params.type == "expenditure"
          ? "Expenditure"
          : "Sale & Revenue",
      mainPath: "/accounting/" + this.$route.params.type + "/",
    };
  },
  watch: {
    $route: function () {
      this.title =
        this.$route.params.type == "expenditure"
          ? "Expenditure"
          : "Sale & Revenue";
      this.mainPath = "/accounting/" + this.$route.params.type + "/";
    },
  },
};
</script>

<style scoped>
.btn.active {
  background: #0090da !important ;
}
.sticky-bar {
  position: sticky;
  top: 60px;
  z-index: 100;
  background: white;
  padding: 20px 20px 1px 20px;
}
</style>
